import type { QueryClient } from '@tanstack/react-query';
import { invalidateAfterUpload } from '../../lib/queries.ts';

/**
 * Refresh a folder listing after something appeared or moved in it.
 *
 * Deliberately blunt: a copy or a paste can add a folder, a file, a sheet and
 * a document in one go, and the dashboard's counts change too. Working out
 * precisely which of the four lists to invalidate would save a request nobody
 * notices and get it wrong the first time a new kind is added.
 */
export function refreshFolder(client: QueryClient, folderId: string | null): Promise<unknown> {
  return Promise.all([
    invalidateAfterUpload(client, folderId),
    client.invalidateQueries({ queryKey: ['folders'] }),
    client.invalidateQueries({ queryKey: ['files'] }),
  ]);
}
